import { isOrtexApp } from "./utils";

/**
 * Whether storage holds a sign-in: an Amplify (Cognito) access token, or in the mobile app the
 * stored ORTEX user. Without one the reader is a signed-out visitor (or a crawler) and the user
 * call can only come back as a visitor. Same test as `hasStoredCognitoSession` in `_app.tsx` and
 * the head script in `src/lib/loaderHold.ts`.
 */
export const storageHoldsSession = (keys: string[], ortexUser: string | null, inApp: boolean): boolean => keys.some((key) => key.startsWith("CognitoIdentityServiceProvider") && key.endsWith(".accessToken")) || (inApp && !!ortexUser);

/** {@link storageHoldsSession} on this browser's localStorage; false wherever storage is unavailable. */
export const hasStoredCognitoSession = (): boolean => {
    try {
        return storageHoldsSession(Object.keys(localStorage), localStorage.getItem("ortexUser"), isOrtexApp());
    } catch {
        return false;
    }
};
